import React from "react";
import "../Styles/Navbar.css";
import { useNavigate } from "react-router-dom";
import logo from "../images/investchartslogo.png";

const Navbar = () => {
  const navigate = useNavigate();
  return (
    <div className="navbar">
      <div className="nav__container">
        {/* <h1 className="logo" onClick={() => navigate("/")}>
          InvestCharts
        </h1> */}
        <img src={logo} height="150px" onClick={() => navigate("/")} />
        <div className="nav__menu">
          <div className="signin__frame">
            <p className="signin__text">Sign In</p>
          </div>
          <div className="get__started__button">
            <span className="signup__text">Get Started</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Navbar;
